export function resolveLoginRedirectTarget(redirect?: string, fallbackPath?: string) {
  if (redirect) {
    return redirect
  }

  return fallbackPath || '/'
}
